interface MainnetIconProps {
  className?: string
}

export function MainnetIcon({ className }: MainnetIconProps) {
  return (
    <svg viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_159_30)">
        <path
          d="M72 144C111.764 144 144 111.764 144 72C144 32.2355 111.764 0 72 0C32.2355 0 0 32.2355 0 72C0 111.764 32.2355 144 72 144Z"
          fill="#ECECEC"
        />
        <path
          d="M71.4126 30.769V87.8984L71.9923 88.4767L98.5106 72.8015L71.9923 28.8L71.4126 30.769Z"
          fill="#343434"
        />
        <path d="M71.9923 60.7477V28.8L45.4733 72.8015L71.9923 88.4767V60.7477Z" fill="#8C8C8C" />
        <path
          d="M71.6655 93.8959V114.246L71.9922 115.2L98.5268 77.8304L71.9922 93.4975L71.6655 93.8959Z"
          fill="#3C3C3B"
        />
        <path d="M71.9923 93.4975L45.4733 77.8304L71.9923 115.2V93.4975Z" fill="#8C8C8C" />
        <path d="M98.5106 72.8015L71.9922 60.7477V88.4767L98.5106 72.8015Z" fill="#141414" />
        <path d="M71.9923 88.4767V60.7477L45.4733 72.8015L71.9923 88.4767Z" fill="#393939" />
      </g>
      <defs>
        <clipPath id="clip0_159_30">
          <rect width="144" height="144" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
